import { subscribe, proxy } from 'valtio';
import { derive } from 'valtio/utils';

import { currentConnectionStatus } from '@canvas/canvas-state/connection-status';
import { currentPendingChanges } from '@canvas/canvas-state/pending-changes';
import { createBoardSyncStateMachineV2 } from '@canvas/connection-state/board-sync-v2';

import {
  type ContentSyncState,
  syncContentStateChanges
} from './syncContentStateChanges.ts';

type ReadOnlyState = {
  isReadOnly: boolean;
};

type BoardState = {
  id: string | undefined;
};

const currentBoardState = proxy<BoardState>({ id: undefined });
const currentReadOnlyState = proxy<ReadOnlyState>({ isReadOnly: false });

export function initializeContentSyncMachine() {
  const contentSyncStateMachine: ReturnType<typeof createBoardSyncStateMachineV2> =
    createBoardSyncStateMachineV2();

  const state: ContentSyncState = derive({
    pendingChanges: (get) => get(currentPendingChanges).areChangesPending,
    connectionStatus: (get) => get(currentConnectionStatus).connectionStatus,
    readOnly: (get) => get(currentReadOnlyState).isReadOnly,
    id: (get) => get(currentBoardState).id
  });

  const prevState = {
    pendingChanges: false,
    readOnly: false,
    id: undefined
  };

  subscribe(
    state,
    () => {
      syncContentStateChanges({
        contentSyncStateMachine,
        state,
        prevState
      });
    },
    true
  );
}
